import React from 'react';
import { NavLink } from 'react-router-dom';
import styles from './sidebar.module.css';


const Sidebar = () => {

  return (
    <div className={`${styles.sidebarRoot} d-flex flex-column`}>
      <nav className={`${styles.sidebarContainer} nav flex-column`}>
      <NavLink
        to="/dashboard"
        end
        className={({ isActive }) =>
          `nav-link ${styles.sideBarInicio} ${isActive ? styles.sidebarLinkActive : ''}`
        }
      >
        Inicio
      </NavLink>

      
        <NavLink
          to="/dashboard/ricky"
          className={({ isActive }) =>
            `nav-link ${styles.sidebarLink} ${isActive ? styles.sidebarLinkActive : ''}`
          }
        >
          Ricky Sarkany
        </NavLink>
        <NavLink
          to="/dashboard/sofia"
          className={({ isActive }) =>
            `nav-link ${styles.sidebarLink} ${isActive ? styles.sidebarLinkActive : ''}`
          }
        >
          Sofia Sarkany
        </NavLink>
        
      </nav>
    </div>
  );
};

export default Sidebar;
